"use client";

import React, { Suspense } from "react";
import cx from "classnames";
import Image from "next/image";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";

import Link from "@/components/Link";
import Icon from "@ide/shared/components/Icon";

import CtaInstantConsultation from "@/components/CtaInstantConsultation";
import Menu from "@/components/Menu";
import HamburgerIcon from "@/components/HamburgerIcon";
import ExtendNav from "@/components/ExtendNav";
import PropertySearchModal from "@/components/PropertySearchModal";

import useModalStore from "@/stores/modal";
import { getHistory } from "@/hooks/useHistory";
import useHeader from "./useHeader";
import UserProfileLink from "@/components/UserProfileLink";

const Header = ({
  showInstantConsultation = true,
  showSearch = false,
  showSearchBar = false,
  languageSpecificPaths = undefined,
  barClassName = "",
  darkMode = false,
  user,
}) => {
  const router = useRouter();
  const {
    closeSearchModal,
    isMenuOpen,
    isSearchOpen,
    openSearchModal,
    setIsMenuOpen,
    toggleMobileNav,
  } = useHeader();

  return (
    <header
      className={cx("relative w-full h-12 z-999 transition-colors", barClassName, {
        "bg-black": !isMenuOpen,
        "bg-neutral-900": isMenuOpen,
      })}
      style={{ zIndex: 99 }}
    >
      <div className="h-12 px-4 relative z-50">
        <div className="h-full max-w-root mx-auto flex justify-between items-center">
          <div className="flex flex-1">
            <Link
              href="/"
              className="hidden md:block h-8 aspect-1315/281 shrink-0"
              prefetch={false}
            >
              <Image
                src="/assets/images/logo-white.svg"
                alt="Inside Dubai Estate logo"
                className="h-full"
                width={1315}
                height={281}
              />
            </Link>

            <button
              className="md:hidden w-8 h-8 shrink-0 shadow-lg bg-neutral-900 rounded-full cursor-pointer"
              onClick={() => {
                const { history } = getHistory();

                if (history.length > 1) {
                  router.back();
                } else {
                  router.push("/map");
                }
              }}
            >
              <Icon icon="fa-regular fa-arrow-left text-white" />
            </button>
          </div>

          <div className="flex flex-1 gap-1 md:gap-2 items-center justify-end">
            {showInstantConsultation && <CtaInstantConsultation />}

            {showSearch && (
              <Icon
                icon="fa-solid fa-magnifying-glass"
                className="w-4 cursor-pointer p-2 text-white"
                onClick={isSearchOpen ? closeSearchModal : openSearchModal}
              />
            )}

            <div className="relative w-9 h-9 z-50">
              <HamburgerIcon onClick={toggleMobileNav} active={isMenuOpen} />
            </div>

            <div className="text-white">
              <UserProfileLink user={user} />
            </div>
          </div>
        </div>
      </div>

      <ExtendNav isOpen={isMenuOpen} duration={500} contentContainerClass="pt-12!">
        <Menu onLinkClick={toggleMobileNav} isOpen={isMenuOpen} />
      </ExtendNav>

      {showSearch && (
        <PropertySearchModal
          show={isSearchOpen}
          onClose={closeSearchModal}
          // onReset={() => {
          //   closeSearchModal();
          //   resetForm();
          // }}
          // onSubmit={() => {
          //   closeSearchModal();
          //   handleSubmit();
          // }}
        />
      )}
    </header>
  );
};

export default Header;
